export enum StatusEnum {
    error,
    success
}